<template>
  <div class="doctor-box">
    <doctor
      v-for="doctor in doctorList"
      :doctor="doctor"
      :key="doctor.id"
      @select="doctorSelect"
    />
  </div>
</template>
<script>
import doctor from "./components/doctor.vue";
import bookingDiagnoseService from "@/apis/bookingDiagnose/index.js";
import keyMap from "@/constants/appointment.js";
export default {
  components: {
    doctor,
  },
  data() {
    return {
      doctorList: [],
    };
  },
  created() {
    this.getDoctorList();
  },
  methods: {
    getDoctorList() {
      const query = this.$route.query;
      const params = {
        booking_type: keyMap.appointment,
        department_id: query.departmentId ? Number(query.departmentId) : null,
        doctor_ids: query.doctorIds || null,
      };
      bookingDiagnoseService.doctorList(params).then((res) => {
        this.doctorList = res;
      });
    },
    doctorSelect(doctor) {
      this.$router.push({
        name: "AppointmentConfirm",
        query: {
          doctorId: doctor.id,
          type: keyMap.appointment,
          mode: doctor.booking_mode,
          duid: this.$route.query.duid || undefined,
          mobile: this.$route.query.mobile || undefined,
        },
      });
    },
  },
};
</script>
